/**
 * Stat Card Component
 * Displays a metric with value, label, and trend indicator
 */

import React from 'react';
import { TrendingUp } from 'lucide-react';

export interface StatCardProps {
  value: string | number;
  label: string;
  trend?: string;
  trendValue?: string;
  isLast?: boolean;
}

const StatCard: React.FC<StatCardProps> = ({ value, label, trend, trendValue, isLast }) => (
  <div className="p-4 md:p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between bg-white gap-2">
    <div className="flex-1">
      <h3 className="text-2xl md:text-[28px] font-bold text-[#0B111E] leading-tight font-manrope">{value}</h3>
      <p className="text-xs md:text-sm font-medium text-[#64748B] mt-1 font-manrope">{label}</p>
    </div>
    {trendValue && (
      <div className={`flex items-center gap-1 text-xs md:text-sm font-medium px-2 py-1 rounded-full ${
        trend === 'up' ? 'bg-[#E6F8E4] text-[#458330]' : 'bg-[#FFF4EC] text-[#FBBB25]'
      }`}>
        <TrendingUp size={12} className={trend === 'down' ? 'rotate-180' : ''} />
        {trendValue}
      </div>
    )}
  </div>
);

export default StatCard;
